import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import './Login.css';

const ResetPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        
        if (password !== confirmPassword) {
            return setError('Passwords do not match');
        }

        setLoading(true);

        try {
            const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
            const response = await fetch(`${API_URL}/api/auth/reset-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token, newPassword: password }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage('Password has been successfully updated. Redirecting to login...');
                setTimeout(() => navigate('/login'), 3000);
            } else {
                setError(data.error || 'Failed to update password. Your link may have expired.');
            }
        } catch (err) {
            setError('Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page-wrapper" style={{ backgroundImage: 'linear-gradient(rgba(27, 38, 49, 0.8), rgba(13, 18, 23, 0.8)), url(/Sunnyday_Snapshots/site_view.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <div className="login-container">
                <div className="login-info-panel">
                    <div className="login-info-content">
                        <h2>Set New Password</h2>
                        <p>
                            Please choose a strong password to secure your Observant Security account.
                        </p>
                        <img src="/Sunnyday_Snapshots/cap_on_site_image.jpeg" alt="Security Personnel" style={{ width: '100%', borderRadius: '8px', marginTop: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.3)' }} />
                    </div>
                </div>

                <div className="login-form-panel">
                    <h2>Reset Password</h2>
                    <p className="form-subtitle">Enter your new credentials</p>

                    {error && <div className="error-message">{error}</div>}
                    {message && <div style={{ backgroundColor: 'rgba(40, 167, 69, 0.1)', color: '#28a745', padding: '12px', borderRadius: '6px', marginBefore: '20px', textAlign: 'center', border: '1px solid rgba(40, 167, 69, 0.2)', fontSize: '0.95rem' }}>{message}</div>}

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>New Password</label>
                            <div className="password-input-wrapper">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    placeholder="••••••••"
                                    minLength="6"
                                />
                                <button
                                    type="button"
                                    className="password-toggle-btn"
                                    onClick={() => setShowPassword(!showPassword)}
                                    title={showPassword ? "Hide password" : "Show password"}
                                >
                                    {showPassword ? (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                                            <line x1="1" y1="1" x2="23" y2="23"></line>
                                        </svg>
                                    ) : (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                            <circle cx="12" cy="12" r="3"></circle>
                                        </svg>
                                    )}
                                </button>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Confirm Password</label>
                            <input
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                placeholder="••••••••"
                                minLength="6"
                            />
                        </div>
                        <button type="submit" className="login-btn" disabled={loading}>
                            {loading ? 'Updating...' : 'Set Password'}
                        </button>
                    </form>

                    <div className="auth-links" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <Link to="/login" style={{ color: '#1B2631' }}>Return to Login</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
